<template>
  <div>
    <div class="modal-form">
      <div class="hint"></div>
      <div class="form-body">
        <div class="step-userinfo">
          <Form ref="form">
            <WInput
              name="first_name"
              ref="formItem"
              :placeholder="$t('contactForm.inputList.list')[0].placeholder"
              :error-text="$t('contactForm.inputList.list')[0].error"
              v-model="formData.first_name"
              required
            />
            <WInput
              name="last_name"
              ref="formItem"
              :placeholder="$t('contactForm.inputList.list')[1].placeholder"
              :error-text="$t('contactForm.inputList.list')[1].error"
              v-model="formData.last_name"
              required
            />
            <WInput
              name="role"
              ref="formItem"
              :placeholder="$t('contactForm.inputList.list')[2].placeholder"
              :error-text="$t('contactForm.inputList.list')[2].error"
              v-model="formData.role"
              required
              :options="selectList"
              type="select"
            />
          </Form>
        </div>
      </div>
    </div>
    <div class="main-footer">
      <Button @click="next" size="small">{{ $t("contactForm.button.back") }}</Button>
      <Button @click="next" size="small">{{ $t("contactForm.button.submit") }}</Button>
    </div>
  </div>
</template>

<script>
// import Select from "@/components/Select/index.desktop";
import "../assets/index.desktop.scss";
import Button from "../../Button/button.desktop";
import WInput from "@/components/Input/index.desktop";
import Form from "@/components/Form/index";

export default {
  components: { WInput, Button, Form },
  data() {
    return {
      slectList: [],
      formData: {
        first_name: "",
        last_name: "",
        role: "",
      },
    };
  },
  methods: {
    next() {
      const result = this.$refs.form.submit();
      if (result) this.$emit("nextForm", "second", this.formData);
    },
  },
  created() {
    this.selectList = this.$t("contactForm.inputList.selectList").map(
      ({ name: item, translate }) => ({
        name: item,
        value: translate,
      })
    );
  },
};
</script>

<style lang="scss" scoped>
.step-userinfo {
}
</style>
